import * as React from 'react';
import { Typography, Box, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { COLORS } from '../constants/constants';
import { lighten, darken } from '@mui/system';
import Layout from '../components/Layout';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';
export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Layout>
      <Header />
      <Box
        component="section"
        sx={{
          py: { xs: 6, md: 8 },
          px: { xs: 2, md: 4 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'url(/images/overlay-1.webp) center/cover no-repeat',
          position: 'relative',
          minHeight: '60vh',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            zIndex: 1,
          },
        }}
      >
        <Container
          maxWidth="md"
          sx={{
            position: 'relative',
            zIndex: 2,
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
              maxWidth: 600,
              mx: 'auto',
              bgcolor: 'rgba(255, 255, 255, 0.8)',
              borderRadius: 3,
              p: { xs: 3, md: 4 },
              border: '1px solid rgba(0, 0, 0, 0.1)',
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem' },
                fontWeight: 800,
                lineHeight: 1.2,
                color: '#1a202c',
                mb: 2,
              }}
            >
              404
            </Typography>

            <Typography
              variant="h2"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.4rem' },
                fontWeight: 700,
                lineHeight: 1.2,
                color: '#1a202c',
                mb: 2,
              }}
            >
              {t('NotFoundPage00')}
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontSize: { xs: '1rem', md: '1.1rem' },
                color: '#4a5568',
                lineHeight: 1.6,
                maxWidth: 500,
                mb: 4,
              }}
            >
              {t('NotFoundPage01')}
            </Typography>

            <Button
              variant="contained"
              onClick={() => navigate('/')}
              sx={{
                background: '#FF7720',
                color: 'white',
                px: 3,
                py: 1,
                fontSize: '1rem',
                fontWeight: 600,
                borderRadius: '8px',
                textTransform: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                boxShadow: '0 4px 15px rgba(252, 164, 68, 0.3)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 20px rgba(252, 164, 68, 0.4)',
                  background: '#FF7720',
                },
              }}
            >
              {t('NotFoundPage02')}
              <Box component="span" sx={{ fontSize: '1.2rem' }}>→</Box>
            </Button>
          </Box>
        </Container>
      </Box>
      <Footer />
      <LanguageSwitcher />
    </Layout>
  );
}